// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".com-contanier[data-v-526b7bb0] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.com-contanier .range-separator[data-v-526b7bb0] {\n  margin: 0 7px;\n}\n", ""]);
// Exports
module.exports = exports;
